import { Client } from 'types/api/attacks/client'
import { TargetingStrategy } from 'types/api/attacks/details/targeting'
import { K8sClient } from 'types/api/kubernetes/kubernetes'
import { LoadGenerator } from 'types/api/services/load-generator'
import { ScheduleSettings, ScheduleTriggerType } from 'types/schedules/default'

export type ServiceIgnoreReason = 'UNIMPORTANT' | 'UNRECOGNIZED' | 'INCORRECT'

export interface ServiceIgnoredInfo {
  reason: ServiceIgnoreReason
  detail?: string
}

export interface ServiceActiveTargets {
  clients: Client[]
  k8sClients: K8sClient[]
}

export interface SchedulableTest {
  reliabilityTestId: string
  dependencyId?: string
  status: ScheduleTriggerType
}

export interface ServiceOwner {
  firstName?: string
  lastName?: string
  identifier: string
}

// TODO: Rename this to Service when we refactor the existing `Service`
export interface UserDefinedService {
  teamId: string
  serviceId: string
  targetingStrategy: TargetingStrategy
  processSignature?: string
  processName?: string
  processId?: string
  name: string
  description?: string | null
  createdAt: Date | string
  updatedAt: Date | string // the date/time of any change to the service
  statusCheckIds?: string[]
  scheduleSettings?: ScheduleSettings
  schedulableTests: SchedulableTest[]
  autoCreatingJiraTicketsEnabled: boolean
  defaultJiraIssueFields: UserDefinedServiceJiraDefaults
  modifiedDate: string // the date/time of any user-initiated change to the service
  loadGenerators?: LoadGenerator[]
  tags: {
    environment?: string
    [key: string]: string
  }
  serviceOwner?: ServiceOwner
}

export type RunAllTestRequest = {
  tests: string[]
}

export interface Process {
  id: string
  name: string
  shortProcessCmd: string
  characteristics: Record<string, string>
}

export enum ProcessProvenance {
  ProcessData = 'PROCESSDATA',
  Container = 'CONTAINER',
  Kubernetes = 'KUBERNETES'
}
